// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Add your existing CSS here */

.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 2vh;
  background-color: #000000;
  color: white;
}

.navbar-brand {
  font-size: 1.5rem;
}

.navbar-menu {
  display: flex;
  align-items: center;
}

.dropdown {
  position: relative;
  display: inline-block;
}

.dropdown-button {
  background-color: #333;
  color: white;
  padding: 0.5rem 1rem;
  font-size: 1rem;
  border: none;
  cursor: pointer;
}

.dropdown-content {
  display: none;
  position: absolute;
  background-color: #f9f9f9;
  min-width: 160px;
  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
  z-index: 1;
}

.dropdown-content a {
  color: black;
  padding: 12px 16px;
  text-decoration: none;
  display: block;
}

.dropdown-content a:hover {
  background-color: #f1f1f1;
}

.dropdown:hover .dropdown-content {
  display: block;
}

.dropdown:hover .dropdown-button {
  background-color: #555;
}

.plans-container {
  display: flex;
  flex-wrap: wrap;
  /* justify-content: space-around; */
  justify-content: space-between;
  /* margin: 2rem 0; */
  padding: 20px;
  
}

.plan-card {
  /* background-color: white;
  border: 1px solid #ddd;
  border-radius: 5px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  margin: 1rem;
  padding: 1rem;
  width: 250px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  text-align: center; */
  width: 240px; /* Adjust the width to display multiple cards in one row */
  background-color: #f9f9f9;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);

}

.plan-header {
  margin-bottom: 20px;
}

.plan-header h2 {
  font-size: 1.5rem;
  margin-bottom: 10px;
}

.plan-price {
  font-size: 1.2rem;
  margin-bottom: 5px;
  font-weight: bold;
}
.plan-agents {
  font-size: 1rem;
  color: #666;
}
.plan-features {
  list-style: none;
  padding-left: 0;
  text-align: left;
  margin-top: 20px;
}

.plan-features li {
  margin-bottom: 8px;
}

.plan-button {
  background-color: #ff5733;
  color: white;
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  margin-top: 20px;
}

.plan-button:hover {
  opacity: 0.9;
}

.plan-header-line {
  /* height: 4px;
  background-color: #4CAF50; /* Change this color as needed */
  /* border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  margin-bottom: 1rem; */ 
  width: 100%;
  height: 5px;
  margin-bottom: 10px;
  border-radius: 4px 4px 0 0;
}

@media (max-width: 768px) {
  .plans-container {
    flex-direction: column;
    align-items: center;
  }

  .plan-card {
    width: 100%;
  }
}
.plan-price, .plan-agents, .plan-features, .plan-button {
  margin: 0.5rem 0;
}
.plan-price, .plan-agents {
  font-size: 1.2rem;
  font-weight: bold;
}

.plan-features {
  list-style: none;
  padding: 0;
  text-align: left;
}

.plan-features li {
  margin: 0.5rem 0;
}

.plan-button {
 
  color: white;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  border-radius: 3px;
  align-self: center;
}


.plan-button:hover {
  background-color: #45a049; /* Change this color as needed */
}
.footer {
  background-color: #082850; /* Dark blue background */
  color: white;
  padding: 20px;
  text-align: center;
  margin-top: auto; /* Ensures the footer stays at the bottom */
}

.footer-content {
  display: flex;
  flex-direction: column; /* Stack items vertically */
  justify-content: center; /* Center vertically */
  align-items: center; /* Center horizontally */
  text-align: center;
  max-width: 1200px;
  margin: 0 auto;
}

.footer-links,
.footer-social {
  display: flex;
  justify-content: center; /* Center links */
  margin-top: 10px; /* Add some space above */
}

.footer-links a,
.footer-social a {
  color: white;
  text-decoration: none;
  margin-right: 20px;
}

.footer-social a {
  margin: 0 10px;
}

.footer-bottom {
  margin-top: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/PlanSelection.css"],"names":[],"mappings":"AAAA,+BAA+B;;AAE/B;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,4CAA4C;EAC5C,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mCAAmC;EACnC,8BAA8B;EAC9B,oBAAoB;EACpB,aAAa;;AAEf;;AAEA;EACE;;;;;;;;;;uBAUqB;EACrB,YAAY,EAAE,0DAA0D;EACxE,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,wCAAwC;;AAE1C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE;6DAC2D;EAC3D;;wBAEsB;EACtB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;EACb;AACF;AACA;EACE,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,YAAY;EACZ,YAAY;EACZ,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,kBAAkB;AACpB;;;AAGA;EACE,yBAAyB,EAAE,gCAAgC;AAC7D;AACA;EACE,yBAAyB,EAAE,yBAAyB;EACpD,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB,EAAE,2CAA2C;AAC/D;;AAEA;EACE,aAAa;EACb,sBAAsB,EAAE,2BAA2B;EACnD,uBAAuB,EAAE,sBAAsB;EAC/C,mBAAmB,EAAE,wBAAwB;EAC7C,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,uBAAuB,EAAE,iBAAiB;EAC1C,gBAAgB,EAAE,yBAAyB;AAC7C;;AAEA;;EAEE,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":["/* Add your existing CSS here */\n\n.navbar {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 2vh;\n  background-color: #000000;\n  color: white;\n}\n\n.navbar-brand {\n  font-size: 1.5rem;\n}\n\n.navbar-menu {\n  display: flex;\n  align-items: center;\n}\n\n.dropdown {\n  position: relative;\n  display: inline-block;\n}\n\n.dropdown-button {\n  background-color: #333;\n  color: white;\n  padding: 0.5rem 1rem;\n  font-size: 1rem;\n  border: none;\n  cursor: pointer;\n}\n\n.dropdown-content {\n  display: none;\n  position: absolute;\n  background-color: #f9f9f9;\n  min-width: 160px;\n  box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n  z-index: 1;\n}\n\n.dropdown-content a {\n  color: black;\n  padding: 12px 16px;\n  text-decoration: none;\n  display: block;\n}\n\n.dropdown-content a:hover {\n  background-color: #f1f1f1;\n}\n\n.dropdown:hover .dropdown-content {\n  display: block;\n}\n\n.dropdown:hover .dropdown-button {\n  background-color: #555;\n}\n\n.plans-container {\n  display: flex;\n  flex-wrap: wrap;\n  /* justify-content: space-around; */\n  justify-content: space-between;\n  /* margin: 2rem 0; */\n  padding: 20px;\n  \n}\n\n.plan-card {\n  /* background-color: white;\n  border: 1px solid #ddd;\n  border-radius: 5px;\n  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);\n  margin: 1rem;\n  padding: 1rem;\n  width: 250px;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-between;\n  text-align: center; */\n  width: 240px; /* Adjust the width to display multiple cards in one row */\n  background-color: #f9f9f9;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 20px;\n  margin-bottom: 10px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n\n}\n\n.plan-header {\n  margin-bottom: 20px;\n}\n\n.plan-header h2 {\n  font-size: 1.5rem;\n  margin-bottom: 10px;\n}\n\n.plan-price {\n  font-size: 1.2rem;\n  margin-bottom: 5px;\n  font-weight: bold;\n}\n.plan-agents {\n  font-size: 1rem;\n  color: #666;\n}\n.plan-features {\n  list-style: none;\n  padding-left: 0;\n  text-align: left;\n  margin-top: 20px;\n}\n\n.plan-features li {\n  margin-bottom: 8px;\n}\n\n.plan-button {\n  background-color: #ff5733;\n  color: white;\n  padding: 10px 20px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  margin-top: 20px;\n}\n\n.plan-button:hover {\n  opacity: 0.9;\n}\n\n.plan-header-line {\n  /* height: 4px;\n  background-color: #4CAF50; /* Change this color as needed */\n  /* border-top-left-radius: 5px;\n  border-top-right-radius: 5px;\n  margin-bottom: 1rem; */ \n  width: 100%;\n  height: 5px;\n  margin-bottom: 10px;\n  border-radius: 4px 4px 0 0;\n}\n\n@media (max-width: 768px) {\n  .plans-container {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .plan-card {\n    width: 100%;\n  }\n}\n.plan-price, .plan-agents, .plan-features, .plan-button {\n  margin: 0.5rem 0;\n}\n.plan-price, .plan-agents {\n  font-size: 1.2rem;\n  font-weight: bold;\n}\n\n.plan-features {\n  list-style: none;\n  padding: 0;\n  text-align: left;\n}\n\n.plan-features li {\n  margin: 0.5rem 0;\n}\n\n.plan-button {\n \n  color: white;\n  border: none;\n  padding: 0.5rem;\n  cursor: pointer;\n  border-radius: 3px;\n  align-self: center;\n}\n\n\n.plan-button:hover {\n  background-color: #45a049; /* Change this color as needed */\n}\n.footer {\n  background-color: #082850; /* Dark blue background */\n  color: white;\n  padding: 20px;\n  text-align: center;\n  margin-top: auto; /* Ensures the footer stays at the bottom */\n}\n\n.footer-content {\n  display: flex;\n  flex-direction: column; /* Stack items vertically */\n  justify-content: center; /* Center vertically */\n  align-items: center; /* Center horizontally */\n  text-align: center;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.footer-links,\n.footer-social {\n  display: flex;\n  justify-content: center; /* Center links */\n  margin-top: 10px; /* Add some space above */\n}\n\n.footer-links a,\n.footer-social a {\n  color: white;\n  text-decoration: none;\n  margin-right: 20px;\n}\n\n.footer-social a {\n  margin: 0 10px;\n}\n\n.footer-bottom {\n  margin-top: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
